import React from "react";
var __jsx = React.createElement;
import { Synapse } from "../../components/Synapse/components";
export default function SynapsePage() {
  return /*#__PURE__*/React.createElement(Synapse, {
    theme: "system"
  });
}